//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//


import ProfileData from '~/components/profile/mixins/ProfileData'
import { BCarousel, BCarouselSlide, BSpinner } from 'bootstrap-vue'

import { validationMixin } from 'vuelidate'
import {email, required, minLength, maxLength} from "vuelidate/lib/validators"


export default {

    name: 'ProfileProductPopup',

    mixins: [ProfileData, validationMixin],

    components: { BCarousel, BCarouselSlide, BSpinner },

    props: {
        company: {
        },
        product: {
        },
    },

    data() {
        return {
            slide: 0,
            showRequestForm: false,
            name: '',
            email: '',
            message: '',
        }
    },

    validations: {

        name: {
            required
        },
        email: {
            required,
            email
        },
        message: {
            required,
            maxLength: maxLength(2500)
        },


    },

    methods: {

        requestFormShow() {
            this.showRequestForm = true
        },

        requestFormHide() {
            this.showRequestForm = false
            this.resetRequestForm()
        },

        validate() {

            this.$v.$touch()

            if (this.$v.$invalid) {
                this.$toast.global.my_error({message: 'Please fill all required fields'})
                return false
            }

            return true
        },

        sendRequest() {

            const validated = this.validate()

            if(validated === false)  {
                return false
            }

            let _this = this
            const formData = {
                name: this.name,
                email: this.email,
                message: this.message
            }

            this.$axios.post(this.$ziggy.route('profile.products.request.send', {'product': this.product.id}), formData)
                .then((response) => {
                    _this.$toast.global.my_success({message: 'Request send.'})
                    _this.requestFormHide()
                })
                .catch((e) => {
                    this.$toast.global.my_error()
                    _this.$logger.captureException(e)
                })

        },

        resetRequestForm() {
            this.name = ''
            this.email = ''
            this.message = ''
            this.$v.$reset()
        }

    },

    computed: {

      requestFormContentName() {
          return 'ProductPopup: profile'
      }

    },


}

